module.exports = __webpack_public_path__ + "media/images/icons/outlined/branches-88b95395fdfaf9a0882afd84e0536f9e.svg";